import { array, object, string } from 'yup'
import { safify } from '../utils/safify'

export const channels = array()
  .of(
    object().shape({
      channel_type: string(),
      prompt_library: string().optional(),
      title: string().optional(),
      post_at: string().optional(),
    }),
  )
  .default([])
  .meta({
    label: '',
    autoFill: true,
  })
  .transform(safify)
